// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3obvk","toggleWrap":"styles_toggleWrap__3GrNG","content":"styles_content__hdXvg","selectAreaCode":"styles_selectAreaCode__3Q84D"};